
// For Firebase JS SDK v7.20.0 and later, measurementId is optional

export const firebaseConfig = {
            apiKey: "AIzaSyDPK-OO5eGQH8yTKux9dnNnagcPN84AK0E",
            authDomain: "appointment1-e4b31.firebaseapp.com",
            projectId: "appointment1-e4b31",
            storageBucket: "appointment1-e4b31.appspot.com",
            messagingSenderId: "31722136164",
            appId: "1:31722136164:web:e1efca70af620aa37ff571",
            measurementId: "G-SSLNXFLRH7"
};
